// PrivateRoute.tsx
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";

const PrivateRoute = () => {
  const token = Cookies.get("jwt"); // 👈 check from cookie

  return token ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
